import { NoAccessState } from '@artic/ui/no-access-state';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

// Permissions v1 last resort: every section landing (job cards, quality
// packs, projects, products, operating costs, factory admin) was denied, so
// there is nowhere else in the hub to send the user. Deliberately outside
// every section — `route-coverage.spec.ts` allowlists it — so it can never
// itself trigger the guard that lands people here.
export const Route = createFileRoute('/no-access')({
  component: NoAccessPage,
});

function NoAccessPage() {
  const { t } = useTranslation('common');

  return (
    <NoAccessState title={t('navigation.noAccess.title')} body={t('navigation.noAccess.body')} />
  );
}
